import { FeatureCollection } from 'geojson'
import { useHasFilters, useHighlightIds } from 'map-filter-view'
import { getClusterFilterPayload } from 'map-style-utils'
import { Source } from 'ms-map-gl'
import { FC, useMemo } from 'react'

import { geojsonify } from '~map-preview/utils/geojsonify'
import { ClusterLayer } from '../../Layers/MarkerLayer/Cluster'
import { CLUSTER_MAX_ZOOM, CLUSTER_SOURCE_ID } from '~map-preview/constants'
import { ClusterZoomPlugin } from '../../Plugins/ClusterZoomPlugin'
import { useMarkerType } from '~map-preview/states/marker'
import { useMapToolbarStore } from '~map-preview/states/mapToolbar'
import { has, isEmpty } from 'lodash'

type ClusterSourceProps = {
  geojson?: FeatureCollection
}

export const ClusterSource: FC<ClusterSourceProps> = geojsonify((props) => {
  const { geojson } = props

  const filterIds = useHighlightIds()
  const hasFilters = useHasFilters()
  const markerType = useMarkerType()
  const { visualization } = useMapToolbarStore()

  const { filter } = useMemo(
    () => getClusterFilterPayload(filterIds),
    [filterIds]
  )

  const key = useMemo(
    () => `mapstack-points-cluster-${filterIds.join('-')}`,
    [filterIds]
  )

  const showLayer =
    markerType === 'individual' &&
    (isEmpty(visualization) || has(visualization, 'marker'))

  return (
    <>
      <Source
        cluster
        key={key}
        id={CLUSTER_SOURCE_ID}
        type='geojson'
        data={geojson}
        filter={hasFilters ? filter : undefined}
        clusterMaxZoom={CLUSTER_MAX_ZOOM}
        clusterRadius={25}
        // INFO: This is id for hover feature state
        generateId
      >
        {showLayer && <ClusterLayer />}
      </Source>
      <ClusterZoomPlugin />
    </>
  )
})
